import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_MISSED_QUESTIONS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the missed questions.'),
      403: i18n.t('You are not allowed to fetch the missed questions.'),
      404: i18n.t('The missed questions you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the missed questions'),
      default: i18n.t('An error occurred fetching the missed questions.')
    }
  },
  DOWNLOAD_MISSED_QUESTIONS: {
    ERROR: {
      401: i18n.t('You are not authorized to download the missed questions file.'),
      403: i18n.t('You are not allowed to download the missed questions file.'),
      404: i18n.t('The missed questions file you are trying to download do not exist.'),
      500: i18n.t('An error occurred downloading the missed questions file.'),
      default: i18n.t('An error occurred downloading the missed questions file.')
    }
  }
};
